import { atom } from "nanostores";

export const $isCopilotOpen = atom(false);

export const toggleCopilot = (): void => {
  $isCopilotOpen.set(!$isCopilotOpen.get());
};

export const openCopilot = (): void => {
  $isCopilotOpen.set(true);
};

export const closeCopilot = (): void => {
  $isCopilotOpen.set(false);
};
